export default function Macro() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/photos/">
          photography
        </a>
        {' > '}
        <a class="1" href="/photos/macro">
          macro
        </a>
      </p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/macro/alightinthedark.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/alightinthedark_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />A Light in the Dark{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/macro/cubiclabirynth.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/cubiclabirynth_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Cubic Labyrinth
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/macro/fingerauditorium.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/macro/fingerauditorium_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Finger Auditorium{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/macro/fluffycactus.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/fluffycactus_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Fluffy Cactus{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/macro/mozartin-a-jar.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/mozartin-a-jar_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Mozart in-a-jar{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/macro/powerandeject.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/powerandeject_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Power &amp; Eject{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/macro/smileybehindanorigamistar.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/macro/smileybehindanorigamistar_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Smiley Behind an Origami Star{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/macro/spider.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/spider_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Sp&iuml;der
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div align="center">
              <a href="/assets/photo/macro/twistedwonders.jpg" target="_blank">
                <img
                  src="/assets/photo/macro/twistedwonders_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Twisted Wonders{' '}
              </a>
            </div>
          </td>
        </tr>
      </table>
      <p align="left">&nbsp;</p>
    </>
  );
}
